"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterCompact = exports.isTruthy = exports.ensureArray = exports.isReadonlyArray = exports.enumSet = exports.noop = exports.assert = exports.UnreachableCaseError = void 0;
var ts_essentials_1 = require("ts-essentials");
Object.defineProperty(exports, "UnreachableCaseError", { enumerable: true, get: function () { return ts_essentials_1.UnreachableCaseError; } });
Object.defineProperty(exports, "assert", { enumerable: true, get: function () { return ts_essentials_1.assert; } });
Object.defineProperty(exports, "noop", { enumerable: true, get: function () { return ts_essentials_1.noop; } });
var enum_1 = require("./enum");
Object.defineProperty(exports, "enumSet", { enumerable: true, get: function () { return enum_1.enumSet; } });
/**
 * @internal
 * @group Helpers
 */
exports.isReadonlyArray = Array.isArray;
function ensureArray(value) {
    return Array.isArray(value)
        ? value
        : value
            ? [value]
            : [];
}
exports.ensureArray = ensureArray;
/** useful for `Array::filter`. In the frontend app, this is replaced by `Boolean` via DefinePlugin */
exports.isTruthy = Boolean;
exports.filterCompact = exports.isTruthy;
//# sourceMappingURL=index.js.map